import { createSlice } from '@reduxjs/toolkit';

export const surveySlice = createSlice({
  name: 'survey',
  initialState: {
    check_survey: false,
    process: 'LOGIN',
    courseId: null
  },
  reducers: {
    updateSurvey: (state, action) => {
      const { check_survey, process, courseId } = action.payload;
      state.check_survey = check_survey;
      state.process = check_survey ? (process ?? state.process) : 'LOGIN';
      state.courseId = check_survey ? (courseId ?? null) : null;
    }
  }
});

export const {
  updateSurvey
} = surveySlice.actions;

export default surveySlice.reducer;